import React from 'react';
import { Store, ShieldCheck, ShieldQuestion } from 'lucide-react';

export function SellerAgentBadge({ agent, testid }) {
  if (agent.agent_role !== 'seller') return null;
  const ok = agent.domain_status === 'confirmed';
  const Icon = ok ? ShieldCheck : ShieldQuestion;
  return (
    <div className="flex flex-wrap items-center gap-1.5 mb-3" data-testid={testid}>
      <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded bg-sky-500/10 text-sky-300 border border-sky-500/30">
        <Store className="w-3 h-3" /> Seller agent for {agent.merchant_domain}
      </span>
      <span className={`inline-flex items-center gap-1 text-[10px] px-2 py-0.5 rounded border ${ok ? 'border-emerald-500/40 text-emerald-300' : 'border-amber-500/40 text-amber-300'}`} data-testid={`${testid}-domain-status`}>
        <Icon className="w-3 h-3" /> {ok ? 'Domain confirmed' : 'Domain not yet confirmed'}
      </span>
    </div>
  );
}
